import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CartSharedModule } from '@spartacus/cart/base/components';
import {
  CmsConfig,
  DeferLoadingStrategy,
  FeaturesConfigModule,
  I18nModule,
  provideConfig,
  UrlModule,
} from '@spartacus/core';
import { GlobalMessageComponentModule, IconModule, PromotionsModule, SpinnerModule } from '@spartacus/storefront';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { BackorderCartModalComponent } from '../backorder-cart-modal/backorder-cart-modal.component';
import { ItemCounterModule } from '../item-counter/item-counter.module';
import { ShimanoAddToCartComponent } from './add-to-cart.component';

@NgModule({
  imports: [
    CartSharedModule,
    CommonModule,
    RouterModule,
    SpinnerModule,
    PromotionsModule,
    MatIconModule,
    MatTooltipModule,
    FeaturesConfigModule,
    MatButtonModule,
    UrlModule,
    IconModule,
    I18nModule,
    ItemCounterModule,
    GlobalMessageComponentModule,
    DynamicFormsModule,
    FormsModule,
    ShimanoAddToCartComponent,
    BackorderCartModalComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductAddToCartComponent: {
          component: ShimanoAddToCartComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.BackOrderCart,
    }),
  ],
  exports: [ShimanoAddToCartComponent, BackorderCartModalComponent],
})
export class AddToCartModule {}
